const isVerified = (user, company) =>
  user?.identity_verified_state === 'verified' &&
  (company?.business_licence_verified_state === 'verified' || company?.account_type !== 'business')

export default isVerified
